import {MaterialVariation} from '../../../envisia/material/material-management.model';
import {ValidationError, ValidationErrorType} from '../../errorhandling/errorHandling.model';
import {ProductionMachine} from '../../production/machines/production-machine.model';

export interface ProductionStepProp {
  productionStepId: number;
  productionStepNr: number;
  productionStepText: string;
}

export interface ProductionStepModalState {
  modal: 'closed' | 'open';
}

export interface ProductionStepMaterialCondition {
  material_variation_id: number;
  material_variation: MaterialVariation;
  group: number | null;
  production_machine_id: number | null;
  production_machine: ProductionMachine | null;
  rules: any;
}

export interface ProductionStepMaterialConditionForm {
  variation_id: string;
  group: number | null;
  production_machine_id: number | null;
  rules: string;
}

export interface ProductionStepMaterialConditionFormParsed {
  variation_id: string;
  group: number | null;
  production_machine_id: number | null;
  rules: any;
}

export interface ProductionStepMaterialListState extends ValidationError, ProductionStepModalState {
  selected: ProductionStepMaterialCondition | null;
  createOpen: boolean;
}

export type ProductionStepMutationErrorFunction = (errors: ValidationError | null) => void;

type ProductionStepMutationFunction = (
  form: ProductionStepMaterialConditionFormParsed,
  errorFunction: ProductionStepMutationErrorFunction,
) => void;
export interface ProductionStepMutation {
  mutate: ProductionStepMutationFunction;
  isPending: boolean;
}

export function productionStepMutationErrorHandler(
  status: number,
  errors: ValidationErrorType,
): ValidationError {
  switch (status) {
    case 400:
      const keys = Object.keys(errors)
        .filter(k => k !== 'variation_id' && k !== 'group' && k !== 'production_machine_id');
      return {
        errors: {
          'variation_id': errors['variation_id'] ?? null,
          'group': errors['group'] ?? null,
          'production_machine_id': errors['production_machine_id'] ?? null,
          'rules': keys.length > 0 ? errors[keys[0]] : null,
        },
      };
    case 404:
      return {errors: {'variation_id': ['Keine valide Interne Material-Artikelnummer']}};
    case 409:
      return {errors: {'variation_id': ['Interne Material-Artikelnummer wurde bereits im Schritt hinzugefügt']}};
  }
}
